import React from 'react'
import './about.css'
import Headshot from '../../assets/Michael_Fang_Headshot.png'
import {FiAward} from 'react-icons/fi'
import {FiUsers} from 'react-icons/fi'
import {VscLibrary} from 'react-icons/vsc'

const about = () => {
  return (
    <section id="about"> 
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={Headshot} alt="Michael Fang" />
          </div>
        </div>

        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FiAward className="about__icon"/>
              <h5>Education</h5>
              <small>UC Merced, B.S. Cognitive Science</small>
            </article>

            <article className="about__card">
              <FiUsers className="about__icon"/>
              <h5>Focus</h5>
              <small>Product, programs, engineering, and AI tools</small>
            </article>

            <article className="about__card">
              <VscLibrary className="about__icon"/>
              <h5>Approach</h5>
              <small>Thoughtful systems built around people and workflows</small>
            </article>
          </div>
          
          <p>
            I am a UC Merced Cognitive Science graduate with a Computer Science background. I enjoy turning ambiguous needs into practical tools, documentation, and workflows that are easier for people to use.
          </p>
          {/* <p>
            Currently starting out my freelancing career as a front-end developer that specializes in developing e-Commerce sites. I'm actively 
            looking for opportunities to work with new clients to further develop my skills.
          </p> */}
          <p>
            I am exploring product management, technical program management, software engineering, AI tools, user experience, and workflow systems. My work combines technical curiosity with facilitation, research, and clear communication.
          </p>


          <a href="#contact" className="btn btn-primary">Contact Me</a>
        </div>

      </div>
    </section>
  )
}

export default about
